import i18n from 'i18next';
import I18NextHttpBackend from 'i18next-http-backend';
import { initReactI18next } from 'react-i18next';

i18n
  .use(initReactI18next)
  .use(I18NextHttpBackend)
  .init({
    supportedLngs: ['en', 'de'],
    fallbackLng: 'en',
    debug: false,
    backend: {
      loadPath: '/assets/lang/{{lng}}/translation.json',
    },
  });

export default i18n;
